<!--
  HeaderBar · 播放器工具栏（字幕 / 模式开关 / 倍速 / 预设快切）
  注：课程选择和上传已移到「课程包」页面，这里只管播放控制
  props: subMode / adaptive / lockOne / currentRate / speeds
         presets / activePresetId / lessonTitle
  emit:  subClick(mode) / toggleAdaptive() / toggleLock() / rateClick(r)
         changePreset(id) / back()
-->
<template>
  <header class="header-bar">
    <!-- 第一行：返回 + 标题 + 预设快切 -->
    <div class="row toolbar-row" style="margin-bottom:10px;flex-wrap:wrap">
      <button class="back-btn" @click="$emit('back')" title="返回课程包">← 返回</button>
      <span class="chip on" :title="lessonTitle">🎬 {{ lessonTitle || '未命名课程' }}</span>

      <label style="color:var(--mute);font-size:13px;margin-left:auto">
        学习模式：
        <select :value="activePresetId" @change="$emit('changePreset', $event.target.value)"
                style="min-width:180px;margin-left:4px"
                title="选择后立即生效；在「播放设置」页可新建/编辑">
          <option v-for="p in presets" :key="p.id" :value="p.id">{{ p.name }}</option>
        </select>
      </label>
    </div>

    <!-- 第二行：字幕 + 模式 + 倍速 -->
    <div class="row toolbar-row">
      <span class="chip" style="color:var(--ink)">字幕：</span>
      <button
        v-for="n in 4" :key="n"
        class="sub-btn"
        :class="{active: subMode === n-1}"
        @click="$emit('subClick', n-1)"
      >{{ n }}·{{ ['关','EN','中','双语'][n-1] }}</button>

      <span style="width:1px;height:20px;background:var(--line);margin:0 4px"></span>

      <button class="mode-btn" :class="{active: adaptive}" title="A 键切换"
              @click="$emit('toggleAdaptive')">🪜 阶梯(A)</button>
      <button class="mode-btn" :class="{active: lockOne}" title="L 键切换"
              @click="$emit('toggleLock')">🔒 单句循环(L)</button>

      <span style="width:1px;height:20px;background:var(--line);margin:0 4px"></span>

      <span class="chip" style="color:var(--ink)">倍速：</span>
      <div class="row" id="speedBar">
        <button
          v-for="r in speeds" :key="r"
          :data-rate="r"
          :class="{active: Math.abs(r - currentRate) < 0.001}"
          @click="$emit('rateClick', +r)"
        >{{ r }}×</button>
      </div>
    </div>
  </header>
</template>

<script setup>
defineProps({
  subMode: { type: Number, default: 1 },
  adaptive: { type: Boolean, default: false },
  lockOne: { type: Boolean, default: false },
  currentRate: { type: Number, default: 1.0 },
  speeds: { type: Array, default: () => [0.4, 0.5, 0.75, 0.8, 1.0, 1.2, 1.5, 2.0] },
  presets: { type: Array, default: () => [] },
  activePresetId: { type: String, default: 'sequence' },
  lessonTitle: { type: String, default: '' },
})
defineEmits(['subClick', 'toggleAdaptive', 'toggleLock', 'rateClick', 'changePreset', 'back'])
</script>

<style scoped>
.back-btn { padding: 6px 12px; }
</style>
